import React, { useState, useRef } from 'react';
import './DropdownSelector.css';

// Helper imports
import OutsideAlerter from '../../helpers/components/outsideAlerter/OutsideAlerter';

// Icons
import { IoChevronDown } from 'react-icons/io5';
import { IconType } from 'react-icons';

// Type imports
import { DropdownSelectorElement } from '../../types/dropdown/DropdownSelectorElement';

type Props = {
  selectedElement: number;
  elements: DropdownSelectorElement[];
  openToLeft?: boolean;
  className?: string;
  disabled?: boolean;
  onChange: (value: number) => void;
};

const DropdownSelector: React.FC<Props> = ({
  selectedElement,
  elements,
  openToLeft,
  className,
  disabled,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const getSelectedElement = () => {
    const elementIndex = elements.findIndex(
      (x: DropdownSelectorElement) => x.value === selectedElement
    );
    if (elementIndex === -1) {
      return 0;
    }

    return elementIndex;
  };

  const getIcon = (index: number) => {
    if (elements[getSelectedElement()].Icon) {
      const TempIcon: IconType = elements[getSelectedElement()].Icon!;
      return <TempIcon className='nav-icon' />;
    } else if (elements[getSelectedElement()].imgIcon) {
      const imgUrl = elements[getSelectedElement()].imgIcon;
      return (
        <img
          src={imgUrl}
          alt={elements[getSelectedElement()].label}
          className='nav-icon'
        />
      );
    }
    return null;
  };

  return (
    <OutsideAlerter
      toggleEvent={!disabled ? toggleOpen : undefined}
      dependency={isOpen}
    >
      <div
        className={`DropdownSelector ${className ? className : ''}`}
        ref={wrapperRef}
      >
        <div
          onClick={!disabled ? toggleOpen : undefined}
          className='label-container'
        >
          <div>
            {getIcon(getSelectedElement())}
            <span className='label'>
              {elements[getSelectedElement()].label}
            </span>
          </div>

          <IoChevronDown
            className={`chevron ${isOpen ? 'chevron-up' : null}`}
          />
        </div>
        {isOpen ? (
          <ul className={`menu ${openToLeft ? 'open-left' : ''}`}>
            {elements.map((element: DropdownSelectorElement, index: number) => (
              <li key={index}>
                <div
                  className='link-element'
                  onClick={() => {
                    toggleOpen();
                    onChange(element.value);
                  }}
                >
                  {element.Icon ? <element.Icon className='nav-icon' /> : null}
                  {element.imgIcon ? (
                    <img
                      src={element.imgIcon}
                      alt={element.label}
                      className='nav-icon'
                    />
                  ) : null}
                  <span>{element.label}</span>
                </div>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </OutsideAlerter>
  );
};

export default DropdownSelector;
